import {
  mdiPlus as mdiAdd,
  mdiPaperclip as mdiAttachment,
  mdiCalendar,
  mdiCommentOff as mdiNotesOff,
  mdiCommentText as mdiNotes,
  mdiCancel,
  mdiCheck,
  mdiCheckCircle,
  mdiClose,
  mdiCloseCircle,
  mdiAccountGroup as mdiGroup,
  mdiViewDashboard as mdiDashboard,
  mdiMinus as mdiDash,
  mdiDelete,
  mdiDownload,
  mdiPencil as mdiEdit,
  mdiCircleOutline as mdiEmptyCircle,
  mdiAlertCircle as mdiError,
  mdiUpload as mdiFileUpload,
  mdiFilter,
  mdiHelpCircle as mdiHelp,
  mdiListBox as mdiList,
  mdiMusic as mdiSongs,
  mdiDotsHorizontal as mdiOverflowMenu,
  mdiTimerSand as mdiPending,
  mdiRefresh,
  mdiMagnify as mdiSearch,
  mdiAlert as mdiWarning,
  mdiStar,
  mdiStarOutline as mdiStarEmpty,
  mdiMenuDown,
  mdiArrowLeft,
} from "@mdi/js";

export const appIcons = {
  mdiAdd,
  mdiAttachment,
  mdiBack: mdiArrowLeft,
  mdiCancel,
  mdiCalendar,
  mdiCheck,
  mdiCheckCircle,
  mdiClose,
  mdiCloseCircle,
  mdiDash,
  mdiDashboard,
  mdiDelete,
  mdiDownload,
  mdiEdit,
  mdiEmptyCircle,
  mdiError,
  mdiFileUpload,
  mdiFilter,
  mdiGroup,
  mdiHelp,
  mdiList,
  mdiMenuDown,
  mdiNotesOff,
  mdiNotes,
  mdiSongs,
  mdiStar,
  mdiStarEmpty,
  mdiOverflowMenu,
  mdiRefresh,
  mdiPending,
  mdiSearch,
  mdiWarning,
};
